import { render, staticRenderFns } from "./webview.vue?vue&type=template&id=7639fb18&scoped=true&"
import script from "./webview.js?vue&type=script&lang=js&"
export * from "./webview.js?vue&type=script&lang=js&"
import style0 from "./webview.css?vue&type=style&index=0&id=7639fb18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7639fb18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VProgressCircular})
